module.exports = __webpack_public_path__ + "img/logo.92d543a2.svg";